import { Action, createAction, props } from '@ngrx/store';
import { PhotoAgency } from '../../models/photography-agency.model';

export const GetAllPhotographyAgencies = createAction('[Photographer] Get All', props<{ payload:any }>());

export const GetAllPhotographyAgenciesComplete = createAction('[Photographer] Get All Complete', props<{ payload:PhotoAgency[] }>());

export const PHOTOGRAPHY_AGENCIES = 'photographyAgencies';
